import * as actions from 'actions/HelpCentreActions/catalogActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
const { catalogActionsEnum } = actions;
const defaultState = {
    asyncStatus: INIT,
    data: {},
    selectedSubCatalogId: null
};
export default function subCatalog(state = defaultState, action) {
    switch (action.type) {
        case catalogActionsEnum.SUB_CATALOG_REQUEST:
            return Object.assign({}, state, { asyncStatus: LOADING });
        case catalogActionsEnum.SUB_CATALOG_RESPONSE:
            return Object.assign({}, state, Object.assign({ asyncStatus: SUCCESS }, action.data));
        case catalogActionsEnum.SUB_CATALOG_ERROR:
            return {
                asyncStatus: ERROR
            };
        case catalogActionsEnum.SELECT_SUB_CATALOG:
            return Object.assign({}, state, {
                selectedSubCatalogId: action.id
            });
        default:
            return state;
    }
}
